import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { Box, Typography, Skeleton } from "@mui/material";
//component
import { useFetchData } from "hook/useFetchData";
import PreSchoolService from "Lib/API/PreSchool";
import { ReactComponent as InstallmentIcon } from "assets/icons/recurring-icon.svg";
// direct import
import { Status } from "../Theme";
import { getCurrency } from "helper/numberFormat";

const style = {
  fontWeight: "700 !important",
  fontFamily: "'Poppins' !important",
  fontSize: 18,
  color: "#3f4255",
  marginBottom: 10,
};
const heading = {
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: 15,
  color: "#4f4f4f",
};
const content = {
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: 16,
  color: "#4f4f4f",
};
const box = {
  boxShadow: "0 0 50px 0 rgba(82, 63, 105, .15)",
  padding: "15px 20px",
  borderRadius: 11,
};

// Skeleton for a row item
const SkeletonRow = () => (
  <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
    <Skeleton variant="text" width="40%" height={24} />
    <Skeleton variant="text" width="30%" height={24} />
  </Box>
);

const ParticipantDrawer = ({ drawerData, openModalCharge }) => {
  const {
    data: memberData,
    loading,
    fetchWithDelay,
  } = useFetchData(PreSchoolService.getFormMemberById);

  useEffect(() => {
    if (drawerData?._id) {
      fetchWithDelay(drawerData._id);
    }
  }, [drawerData?._id]);

  const result = memberData?.result || {};

  return (
    <Box className="participantDrawer__container" sx={{ padding: 2 }}>
      {/* Header */}
      <Box
        className="header"
        sx={{ borderBottom: "1px solid #ccc", pb: 1, mb: "0px !important" }}
      >
        <Box className="title">
          <Typography className="name">Renewal info</Typography>
        </Box>
      </Box>

      {/* Status */}
      <Box sx={{ mt: 1, mb: 2 }}>
        <Typography style={style}>Status</Typography>
        <Box style={box}>
          {loading ? (
            <SkeletonRow />
          ) : (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography style={heading}>Current Status</Typography>
              <Typography style={content}>
                <Status type={result.status}>
                  {result?.status || "pending"}
                </Status>
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Household Interests */}
      {loading && (
        <Box sx={{ mt: 1 }}>
          <Typography style={style}>Household Interests</Typography>
          <Box style={{ ...box, display: "flex", flexWrap: "wrap", gap: 1 }}>
            {Array(3)
              ?.fill(0)
              ?.map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  width={80}
                  height={30}
                  sx={{ borderRadius: 1 }}
                />
              ))}
          </Box>
        </Box>
      )}
      {!isEmpty(result?.housingTags) && (
        <Box sx={{ mt: 1 }}>
          <Typography style={style}>Household Interests</Typography>
          <Box style={{ ...box, display: "flex", flexWrap: "wrap", gap: 1 }}>
            {result?.housingTags?.map((el, i) => (
              <Typography
                key={i}
                style={{
                  ...content,
                  padding: "0px 15px",
                  border: "1px solid #ededed",
                  borderRadius: 6,
                  marginRight: 5,
                }}
              >
                {el}
              </Typography>
            ))}
          </Box>
        </Box>
      )}
      {/* Summary */}
      {loading && (
        <Box sx={{ mt: 1, mb: 2 }}>
          <Typography style={style}>Summary</Typography>
          <Box style={{ ...box, minHeight: 100 }}>
            <SkeletonRow />
            <SkeletonRow />
            <SkeletonRow />
            <Box display="flex" justifyContent="flex-end" sx={{ mb: 1 }}>
              <Skeleton variant="text" width="30%" height={24} />
            </Box>
            <Box display="flex" justifyContent="flex-end">
              <Skeleton variant="text" width="30%" height={24} />
            </Box>
          </Box>
        </Box>
      )}
      {!isEmpty(result?.transactions) && (
        <Box sx={{ mt: 1, mb: 2 }}>
          <Typography style={style}>Summary</Typography>
          <Box style={{ ...box, minHeight: 100 }}>
            {result?.transactions?.map((el, i) => (
              <Box
                display="flex"
                justifyContent="space-between"
                sx={{ mb: 1 }}
                key={i}
              >
                <Box display="flex" alignItems="center">
                  <Typography
                    style={{
                      ...heading,
                      color: "rgb(36 85 239)",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => openModalCharge(el?.transactionId)}
                  >
                    {el?.Ledger?.name}
                  </Typography>
                  {el?.isInstallment && (
                    <Box>
                      <InstallmentIcon className="ml-2" />
                    </Box>
                  )}
                </Box>
                <Typography style={content}>
                  {getCurrency()}
                  {el?.amount ?? 0}
                </Typography>
              </Box>
            ))}
            <Box display="flex" justifyContent="flex-end" sx={{ mb: 1 }}>
              <Typography style={{ ...heading, marginRight: 10 }}>
                Total Amount :
              </Typography>
              <Typography style={content}>
                {getCurrency()}
                {result?.totalAmount}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ParticipantDrawer;
